var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('img',{attrs:{"src":require('@/assets/images/catering.png')}})]),_c('van-list',{attrs:{"finished":_vm.finished,"loading":_vm.loading},on:{"load":_vm.getCatering}},_vm._l((_vm.cateringList),function(item){return _c('cateringList',{key:item.id,attrs:{"info":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }